import {
  FETCH_CITIES_LOADING,
  FETCH_CITIES_DONE,
  FETCH_CITIES_ERROR,
  //
  FETCH_CITIES_LOADING_BY_NAME,
  FETCH_CITIES_DONE_BY_NAME,
  FETCH_CITIES_ERROR_BY_NAME,
  //
  FETCH_COUNTRIES_LOADING,
  FETCH_COUNTRIES_DONE,
  FETCH_COUNTRIES_ERROR,
  // cities destination
  FETCH_CITIES_DESTINATION_LOADING,
  FETCH_CITIES_DESTINATION_DONE,
  FETCH_CITIES_DESTINATION_ERROR,
  // city and ports
  FETCH_CITY_PORT_LOADING,
  FETCH_CITY_PORT_DONE,
  FETCH_CITY_PORT_ERROR,

  FETCH_PROVINCE_BY_COUNTRY_LOADING,
  FETCH_PROVINCE_BY_COUNTRY_DONE,
  FETCH_PROVINCE_BY_COUNTRY_ERROR,

  FETCH_CITY_BY_PROVINCE_LOADING,
  FETCH_CITY_BY_PROVINCE_DONE,
  FETCH_CITY_BY_PROVINCE_ERROR,

  FETCH_DISTRICT_BY_CITY_LOADING,
  FETCH_DISTRICT_BY_CITY_DONE,
  FETCH_DISTRICT_BY_CITY_ERROR,

  FETCH_SUBDISTRICT_BY_DISTRICT_LOADING,
  FETCH_SUBDISTRICT_BY_DISTRICT_DONE,
  FETCH_SUBDISTRICT_BY_DISTRICT_ERROR
} from './actions'

export default {
  //
  [FETCH_CITIES_LOADING] (state) {
    state.isLoading = true
  },

  [FETCH_CITIES_DONE] (state, items) {
    state.city = items
    state.isLoading = false
  },

  [FETCH_CITIES_ERROR] (state, error) {
    state.error = error
    state.isLoading = false
  },
  //
  [FETCH_COUNTRIES_LOADING] (state) {
    state.isLoadingCountries = true
  },

  [FETCH_COUNTRIES_DONE] (state, items) {
    state.country = items
    state.isLoadingCountries = false
  },

  [FETCH_COUNTRIES_ERROR] (state, error) {
    state.error = error
    state.isLoadingCountries = false
  },
  //
  [FETCH_CITIES_LOADING_BY_NAME] (state) {
    state.isLoading = true
  },

  [FETCH_CITIES_DONE_BY_NAME] (state, items) {
    state.items = items
    state.isLoading = false
  },

  [FETCH_CITIES_ERROR_BY_NAME] (state, error) {
    state.error = error
    state.isLoading = false
  },
  //
  // DESTINATION CITIES
  [FETCH_CITIES_DESTINATION_LOADING] (state) {
    state.isLoadingDestination = true
  },

  [FETCH_CITIES_DESTINATION_DONE] (state, items) {
    state.destinationCities = items
    state.isLoadingDestination = false
  },

  [FETCH_CITIES_DESTINATION_ERROR] (state, error) {
    state.errorDestination = error
    state.isLoadingDestination = false
  },
  //

  [FETCH_CITY_PORT_LOADING] (state, routeType) {
    if (routeType === 'origin') {
      state.isLoadingCityPortsOrigin = true
    } else {
      state.isLoadingCityPortsDestination = true
    }
  },
  [FETCH_CITY_PORT_DONE] (state, items) {
    const {data, routeType} = items
    if (routeType === 'origin') {
      state.cityPortsOrigin = data
      state.isLoadingCityPortsOrigin = false
    } else {
      state.cityPortsDestination = data
      state.isLoadingCityPortsDestination = false
    }
  },
  [FETCH_CITY_PORT_ERROR] (state, items) {
    const {error, routeType} = items
    if (routeType === 'origin') {
      state.errorCityPortsOrigin = error
      state.isLoadingCityPortsOrigin = false
    } else {
      state.errorCityPortsDestination = error
      state.isLoadingCityPortsDestination = false
    }
  },

  [FETCH_PROVINCE_BY_COUNTRY_LOADING] (state) {
    state.isLoadingProvincesByCountryId = true
  },
  [FETCH_PROVINCE_BY_COUNTRY_DONE] (state, items) {
    state.provincesByCountryId = items
    state.isLoadingProvinceByCountryId = false
  },
  [FETCH_PROVINCE_BY_COUNTRY_ERROR] (state, error) {
    state.errorProvincesByCountryId = error
    state.isLoadingProvinceByCountryId = false
  },

  [FETCH_CITY_BY_PROVINCE_LOADING] (state) {
    state.isLoadingCityByProvinceId = true
  },
  [FETCH_CITY_BY_PROVINCE_DONE] (state, items) {
    state.cityByProvinceId = items
    state.isLoadingCityByProvinceId = false
  },
  [FETCH_CITY_BY_PROVINCE_ERROR] (state, error) {
    state.errorCityByProvinceId = error
    state.isLoadingCityByProvinceId = false
  },

  [FETCH_DISTRICT_BY_CITY_LOADING] (state) {
    state.isLoadingDistrictByCityId = true
  },
  [FETCH_DISTRICT_BY_CITY_DONE] (state, items) {
    state.districtByCityId = items
    state.isLoadingDistrictByCityId = false
  },
  [FETCH_DISTRICT_BY_CITY_ERROR] (state, error) {
    state.errorDistrictByCityId = error
    state.isLoadingDistrictByCityId = false
  },

  [FETCH_SUBDISTRICT_BY_DISTRICT_LOADING] (state) {
    state.isLoadingSubdistrictByDistrictId = true
  },
  [FETCH_SUBDISTRICT_BY_DISTRICT_DONE] (state, items) {
    state.subdistrictByDistrictId = items
    state.isLoadingSubdistrictByDistrictId = false
  },
  [FETCH_SUBDISTRICT_BY_DISTRICT_ERROR] (state, error) {
    state.errorSubdistrictByDistrictId = error
    state.isLoadingSubdistrictByDistrictId = false
  }
  
}



// WEBPACK FOOTER //
// ./src/store/modules/city/mutations.js